"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var withAnalyticsTracker_1 = require("./withAnalyticsTracker");

exports.withAnalyticsTracker = withAnalyticsTracker_1.withAnalyticsTracker;